export default {
    $gold: '#DCB13C',
    $aqua: '#57BDA2',
    $teal: '#2493A2',
    $blue100: '#304A78',
    $blue200: '#2C3259',
    $blue300: '#0A0E28',
}